import { ref } from '@vue/composition-api';
import { candidateStatus } from '@/enums';
import useCandidates from '@/compositions/useCandidates';
import useKanbanDialogs from '@/compositions/useKanbanDialogs';
import Sortable from 'sortablejs';

const activeCandidate = ref(null);

export default function useKanban({ root, candidates = [], clear = false } = {}) {
  const { updateStatus, fetchById } = useCandidates();
  const kanbanContainer = ref(null);

  const {
    jobOfferDialog, inofficeInterviewDialog,
    inviteMethodDialog, rejectNotificationDialog,
  } = useKanbanDialogs();

  if (clear) {
    activeCandidate.value = null;
  }

  const calculateColWidth = (cols) => {
    const minWidth = 168;
    const maxWidth = 250;
    const containerWidth = kanbanContainer.value.clientWidth;
    const margin = (cols - 2) * 4;
    const realWidth = (containerWidth - 100 - margin) / cols;

    if (realWidth > maxWidth) {
      return maxWidth;
    }

    if (realWidth < minWidth) {
      return minWidth;
    }

    return realWidth;
  };

  async function updateBlock(id, status) {
    try {
      await fetchById(id);
      activeCandidate.value = candidates.value.find((c) => Number(c.id) === Number(id));

      await updateStatus(id, status);

      if (status === candidateStatus.DECLINED) {
        rejectNotificationDialog.value = true;
        return;
      }

      if (status === candidateStatus.INOFFICE_INTERVIEW) {
        inofficeInterviewDialog.value = true;
        return;
      }

      if (status === candidateStatus.JOB_OFFER) {
        jobOfferDialog.value = true;
        return;
      }

      if (status === candidateStatus.INVITED) {
        inviteMethodDialog.value = true;
        return;
      }
    } catch (e) {
      console.log(e);
      root.$toast.error(e.message);
      // TODO: Сделать нормальный ролбэк.
      root.$router.go(0);
    }
  }

  function createStatusSortMap(statuses, stages) {
    return statuses.map((s, index) => {
      const status = stages.find((stage) => s === stage.status);
      return {
        sort: index,
        id: status.id,
      };
    });
  }

  function enableDrag(stages, callbackOnDrag) {
    const el = document.querySelector('.drag-list');
    if (!el) return null;
    const sortable = new Sortable(el, {
      sort: true,
      direction: 'horizontal',
      animation: 150,
      disabled: root.$vuetify.breakpoint.mdAndDown,
      onSort: () => {
        const nodes = document.querySelectorAll('.drag-column:not(.gu-mirror)');
        const statuses = Array.from(nodes).map((n) => n.querySelector('.drag-inner-list').dataset.status);
        const map = createStatusSortMap(statuses, stages.value);
        callbackOnDrag(map);
      },
    });
    return sortable;
  }

  return {
    activeCandidate,
    updateBlock,
    rejectNotificationDialog,
    inviteMethodDialog,
    inofficeInterviewDialog,
    jobOfferDialog,
    kanbanContainer,
    calculateColWidth,
    enableDrag,
  };
}
